import Vue from "vue";

// 全局的过滤器 

// 转换成小写字母
Vue.filter("lower", function (value) {
    if (!value) {
        return;
    }
    return value.toLowerCase();
});

Vue.filter("datetime", function (value) {
    if(!value){
        return value
    }
    var date = new Date(value)
    var month = date.getMonth() + 1;
    var day   = date.getDate();
    var hour = date.getHours();//获取系统时间
    var minute = date.getMinutes(); //分
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
        day = "0" + day;
    }
    if (hour < 10) {
        hour = "0" + hour;
    }
    if (minute < 10) {
        minute = "0" + minute;
    }
    return month + "月" + day + "日"+" "+hour+":"+minute;
});
// 去左右空格
Vue.filter("trim", function (value) {
    if (!value) {
        return;
    }
    return value.replace(/(^\s*)|(\s*$)/g, "");
});

// 保留两位小数 
Vue.filter("reserveDecimal", function (value) {
    var f_x = parseFloat(value);
    var f_x = Math.floor(value * 100) / 100;
    var s_x = f_x.toString();
    var pos_decimal = s_x.indexOf('.');
    if (pos_decimal < 0) {
        pos_decimal = s_x.length;
        s_x += '.';
    }
    while (s_x.length <= pos_decimal + 2) {
        s_x += '0';
    }
    return s_x;
});
//格式时间
Vue.filter("dateNumber", function (value) {
    if(!value){
        return value
    }
    var year  = value.getFullYear();
    var month = value.getMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }
    return year + "年" + month + "月";
});
// 手机号中间四位星号
Vue.filter("FilterPhoneNumber", function (value) {
    if (!value) {
        return;
    }
    var reg = /^(\d{3})\d*(\d{4})$/;
    return  value.replace(reg,'$1****$2')
});

// 全局的组件 

// 头部
import Head from "@/components/Head.vue";
Vue.component("Head", Head);

// 轮播图
import SwipeDemo from "../components/SwipeDemo.vue";
Vue.component("SwipeDemo",SwipeDemo);

// 轮播图
import SwipeItem from "../components/SwipeItem.vue";
Vue.component("SwipeItem",SwipeItem);

